var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  markActiveButtons(document);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) {
    setupGrid(grid);
  }
});

/* Delegated click handler: works for carousel clones and AJAX-loaded cards,
   which never receive per-element listeners. */
document.addEventListener('click', function (e) {
  var button = e.target.closest ? e.target.closest(selectors.button) : null;
  if (!button) return;
  var productHandle = button.dataset.productHandle || false;
  if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
  updateWishlist(productHandle);
  var inList = wishlistContains(productHandle);
  document.querySelectorAll(selectors.button + '[data-product-handle="' + productHandle + '"]').forEach(function (btn) {
    btn.classList.toggle(BUTTON_ACTIVE_CLASS, inList);
    btn.classList.add('loading-wishlist', 'adding-wishlist');
  });
  setTimeout(function () {
    document.querySelectorAll('.loading-wishlist').forEach(function (b) { b.classList.remove('loading-wishlist'); });
  }, 1000);
  setTimeout(function () {
    document.querySelectorAll('.adding-wishlist').forEach(function (b) { b.classList.remove('adding-wishlist'); });
  }, 2000);
});

var markActiveButtons = function (root) {
  var buttons = root.querySelectorAll(selectors.button) || [];
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (productHandle && wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
  });
};

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var wihslitExistBtn = document.querySelector('.wishlist-page');
  if (wishlist.length > 0 && wihslitExistBtn) {
    wihslitExistBtn.classList = 'wishlist_exists';
  }
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    markActiveButtons(grid);
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};
